import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import CardItem from './profile/CardItem';
import '../styles/football-theme.css';

const PackOpeningAnimation = ({ cards, packName, onClose, onFinish, user }) => {
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [showCard, setShowCard] = useState(false);

  useEffect(() => {
    if (cards && cards.length > 0) {
      setShowCard(true);
    }
  }, [cards]);

  useEffect(() => {
    document.body.classList.add('pack-opening-modal-open');
    return () => {
      document.body.classList.remove('pack-opening-modal-open');
    };
  }, []);

  const handleNextCard = () => {
    if (currentCardIndex < cards.length - 1) {
      setShowCard(false);
      setTimeout(() => {
        setCurrentCardIndex(prev => prev + 1);
        setShowCard(true);
      }, 300);
    } else {
      // Last card, finish
      if (onFinish) {
        onFinish();
      }
    }
  };

  const handlePreviousCard = () => {
    if (currentCardIndex > 0) {
      setShowCard(false);
      setTimeout(() => {
        setCurrentCardIndex(prev => prev - 1);
        setShowCard(true);
      }, 300);
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  if (!cards || cards.length === 0) {
    return null;
  }

  const currentCard = cards[currentCardIndex];

  return (
    <div className="fixed inset-0 z-[2147483000] flex items-center justify-center pt-28 pb-4 px-4 bg-black/80 backdrop-blur-sm">
      <div className="w-full max-w-4xl relative flex justify-center">
        <div className="football-card glass-football pt-3 px-5 pb-5 text-center w-fit max-w-full relative">
          {/* Close button */}
          <button
            onClick={handleClose}
            className="absolute top-2 right-2 z-10 w-9 h-9 bg-red-600 hover:bg-red-700 text-white rounded-full flex items-center justify-center transition-all duration-200 shadow-lg"
          >
            <X className="w-5 h-5" />
          </button>
          {/* Pack Name */}
          {packName && (
            <div className="mb-2">
              <h2 className="text-xl font-bold text-white mb-0.5">{packName}</h2>
              <p className="text-gray-300 text-sm">
                Card {currentCardIndex + 1} of {cards.length}
              </p>
            </div>
          )}

          {/* Current Card Display - stessa vista di My Cards, senza bottoni Info/Carrello */}
          <div className="pack-container mb-4 profile-container" style={{ minHeight: '452px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {showCard && currentCard ? (
              <div className={`pack-card ${showCard ? 'flip' : ''}`}>
                <div className="pack-card-front">
                  <div className="profile-gallery-card-scaled">
                    <CardItem
                      card={currentCard}
                      user={user || {}}
                      hideHoverActions
                      isUsedInActiveGameweek={false}
                      onCardListed={() => {}}
                      hasOpenTrade={false}
                      openTrade={null}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="profile-gallery-card-scaled opacity-0 pointer-events-none">
                <div className="profile-card-item football-card glass-football w-[303px] h-[452px] min-w-[303px] min-h-[452px] bg-gray-700 rounded" />
              </div>
            )}
          </div>

          {/* Navigation Buttons */}
          <div className="flex items-center justify-center gap-3 mt-4">
            <button
              onClick={handlePreviousCard}
              disabled={currentCardIndex === 0}
              className="btn-football px-6 py-3 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              ← Previous
            </button>
            
            <div className="scoreboard inline-block px-6 py-3">
              <div className="text-xl font-bold text-yellow-400">
                {currentCardIndex + 1} / {cards.length}
              </div>
            </div>

            <button
              onClick={handleNextCard}
              className="btn-football px-6 py-3"
            >
              {currentCardIndex === cards.length - 1 ? 'Finish →' : 'Next →'}
            </button>
          </div>

          {/* Progress Bar */}
          <div className="mt-4 w-full max-w-md mx-auto">
            <div className="w-full bg-gray-700 rounded-full h-3">
              <div
                className="bg-gradient-to-r from-yellow-400 to-orange-500 h-3 rounded-full transition-all duration-300"
                style={{ width: `${((currentCardIndex + 1) / cards.length) * 100}%` }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackOpeningAnimation;

